<template>
    <div class="side-search side-menu-el">
        <div class="inner">
            <div class="heading">
                <button aria-label="Close search modal" class="open-close-button arrowed-link" @click="closeSearch()">
                    <span>Lukk</span>
                    <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path fill="#005782" d="M8,0 C8.55228475,0 9,0.3581722 9,0.8 L9,7 L15.2,7 C15.6418278,7 16,7.44771525 16,8 C16,8.55228475 15.6418278,9 15.2,9 L9,9 L9,15.2 C9,15.6418278 8.55228475,16 8,16 C7.44771525,16 7,15.6418278 7,15.2 L6.999,9 L0.8,9 C0.3581722,9 0,8.55228475 0,8 C0,7.44771525 0.3581722,7 0.8,7 L6.999,7 L7,0.8 C7,0.3581722 7.44771525,0 8,0 Z"></path></svg>
                </button>
            </div>

            <div class="input-line">
                <div class="search-heading">
                    <div class="input-search">
                        <input  v-model="searchQuery" ref="searchInput" type="search" :placeholder="_('Skriv for å søke')" :aria-label="_('Skriv for å søke')" />
                        <button @click="makeSearch" :aria-label="_('Søke')" class="search-icon">
                            <span v-show="!isSearching" v-html="searchIcon"></span>
                            <span class="search-spin" v-show="isSearching">
                                <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" width="64px" height="64px" viewBox="0 0 128 128" xml:space="preserve"><g><path d="M122.5 69.25H96.47a33.1 33.1 0 0 0 0-10.5h26.05a5.25 5.25 0 0 1 0 10.5z" fill="#203858" fill-opacity="1"/><path d="M112.04 97.83L89.47 84.8a33.1 33.1 0 0 0 5.25-9.1l22.57 13.03a5.25 5.25 0 0 1-5.28 9.1z" fill="#bcc3cd" fill-opacity="0.3"/><path d="M88.68 117.35L75.65 94.78a33.1 33.1 0 0 0 9.1-5.25l13.02 22.57a5.25 5.25 0 1 1-9.1 5.25z" fill="#bcc3cd" fill-opacity="0.3"/><path d="M58.7 122.57V96.5a33.1 33.1 0 0 0 10.5 0v26.07a5.25 5.25 0 0 1-10.5 0z" fill="#bcc3cd" fill-opacity="0.3"/><path d="M30.1 112.1l13.04-22.57a33.1 33.1 0 0 0 9.1 5.25L39.2 117.35a5.25 5.25 0 1 1-9.1-5.25z" fill="#bcc3cd" fill-opacity="0.3"/><path d="M10.6 88.74L33.16 75.7a33.1 33.1 0 0 0 5.25 9.1L15.88 97.83a5.25 5.25 0 1 1-5.25-9.1z" fill="#bcc3cd" fill-opacity="0.3"/><path d="M5.37 58.75h26.06a33.1 33.1 0 0 0 0 10.5H5.37a5.25 5.25 0 0 1 0-10.5z" fill="#a6afbc" fill-opacity="0.4"/><path d="M15.85 30.17L38.4 43.2a33.1 33.1 0 0 0-5.24 9.1L10.6 39.25a5.25 5.25 0 1 1 5.25-9.1z" fill="#8f9bab" fill-opacity="0.5"/><path d="M39.2 10.65l13.03 22.57a33.1 33.1 0 0 0-9.1 5.25l-13-22.57a5.25 5.25 0 1 1 9.1-5.25z" fill="#79889b" fill-opacity="0.6"/><path d="M69.2 5.43V31.5a33.1 33.1 0 0 0-10.5 0V5.42a5.25 5.25 0 1 1 10.5 0z" fill="#62738a" fill-opacity="0.7"/><path d="M97.77 15.9L84.75 38.47a33.1 33.1 0 0 0-9.1-5.25l13.03-22.57a5.25 5.25 0 1 1 9.1 5.25z" fill="#4d6079" fill-opacity="0.8"/><path d="M117.3 39.26L94.7 52.3a33.1 33.1 0 0 0-5.25-9.1l22.57-13.03a5.25 5.25 0 0 1 5.25 9.1z" fill="#364c68" fill-opacity="0.9"/><animateTransform attributeName="transform" type="rotate" values="0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64" calcMode="discrete" dur="1080ms" repeatCount="indefinite"></animateTransform></g></svg>
                            </span>
                        </button>
                    </div>
                </div>

                <div v-show="searchQuery != ''" class="res-text margin-top">{{ _('Results') + ' ' + postFound }}</div>
            </div>

            <div class='type-something margin-top-lg' v-if="searchQuery == ''">
                <h3 class="text-bold h4 text-uppercase">{{_('Type something to see results')}}</h3>
            </div>
            
            <div v-show="searchQuery != ''" ref="resultsSearch" class="results-search">
                <ul v-if="searchResultats && searchResultats.length">
                    <li class="item" v-for="post in searchResultats" :key="post.id" :class="'type-'+post.type">
                        <WpLink class="single-link" :url="post.link || '/'" :title="post.title">
                            <span class="text-bold text-uppercase post-type">{{postTypeName(post.type)}}</span>
                            <h3 class="titler">{{post.title}}</h3>
                        </WpLink>
                    </li>
                </ul>
                <div class="text-bold" v-else-if="!isSearching && searchQuery.length > 2">{{_('Nothing found')}}</div>
                <div class="text-bold" v-else-if="searchQuery.length < 3 && !isSearching">{{_('Type at last 3 characters')}}</div>
            </div>

        </div>
    </div>
</template>

<script>
import _debounce from 'lodash.debounce';

import WpLink from '@/components/elements/WpLink';

import { postTypeName } from '@/helpers';
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { search, cross } from '@/components/../icons';

export default {
    name: 'side-search',
    
    data(){
        return{
            wpvue : window.WPVUE,
            searchIcon: search('#005782'),
            closeIcon: cross('#005782'),
            searchQuery: '',
            isSearching: false,
            postFound: 0,
            searchResultats: [],
        }
    },
    watch:{
        searchQuery(newVal){
            this.userTypingSearch(newVal)
        },
        searchModalOpen(val){
            const input = this.$refs.searchInput;
            if(val && input){
                input.focus()
            }
        }
    },

    methods:{
        ...mapMutations([
            'SEARCH_MODAL_CHANGE_STATE',
        ]),
        ...mapActions([
            'getPost'
        ]),
        postTypeName(name){
            return postTypeName(name)
        },
        closeSearch(){
            this.SEARCH_MODAL_CHANGE_STATE()
        },
        userTypingSearch: _debounce(function (val) {
            this.makeSearch(val)
        }, 250),
        makeSearch(val){
            const VM = this;
            const searchArea = VM.$refs['resultsSearch']
            if(val && val != '' && !VM.isSearching && val.length > 2){
                VM.isSearching = true
                VM.getPost({
                    type: ['page', 'post', 'professions', 'educations', 'ambassadors', 'teachers'],
                    query: val.trim(),
                    limit: 40,
                    calc: true
                }).then(res=> {
                    VM.searchResultats = res.data.posts
                    VM.isSearching = false
                    VM.postFound = Number(res.data.posts_found);
                    if(searchArea){
                        searchArea.style.height = (window.innerHeight - searchArea.offsetTop - 20) + 'px';
                    }

                })
            }else if(val == '' || val.length < 3 ){
                VM.searchResultats = []
                VM.isSearching = false
                VM.postFound = 0;
            }
            
        }
    },
    computed:{
        ...mapGetters([
            'searchValue',
            'searchModalOpen',
        ])
    },
    components:{
        WpLink
    }
    
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.side-search{
    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration {
        -webkit-appearance:none;
    }
    //@include fluid-type($smallResText, $wideResText, 16px, 18px);
    .input-line{
        margin-top: 85px;
        @include mquery($tablet){
            margin-top: 55px;
        }
        @include mquery($phone){
            margin-top: 35px;
        }
        .input-search{
            @include fluid-type($smallResText, $wideResText, 16px, 18px);
            color: $dark;
            position: relative;
            input{
                padding: 12px 25px;
                background-color: #fff;
                border: none;
                border-radius: 50px;
                width: 100%;
                padding-right: 40px;
                &::placeholder{
                    color: $darkLight
                }
            }
            .search-icon{
                position: absolute;
                box-shadow: none;
                top: 50%;
                right: 25px;
                border: none;
                padding: 0;
                margin: 0;
                background: transparent;
                transform: translateY(-50%);
                svg{
                    width: 20px;
                    height: 20px;
                }
            }
        }
        .res-text {
            margin-top: 15px;
            @include fluid-type($smallResText, $wideResText, 12px, 14px);
        }
        
    }
    .results-search{
        margin-top: 35px;
        overflow: auto;
        @include mquery($tablet){
            margin-top: 20px;
        }
        ul{
            margin: 0;
            padding: 0;
            list-style: none;
            li{
                list-style: none;
                margin-bottom: 20px;
                @include mquery($tablet){
                    margin-bottom: 15px;
                }
            }
            .titler{
                margin-top: 0;
                margin-bottom: 0;
            }
            .single-link{
                @include fluid-type($smallResText, $wideResText, 16px, 20px);
                .post-type{
                    @include fluid-type($smallResText, $wideResText, 12px, 14px);
                }
                text-decoration: none;
            }
        }
    }
}
</style>